export function getAll() {
  return [
    {
      value: 0,
      name: "General",
      text: "一般",
    },
    {
      value: 1,
      name: "Saler",
      text: "業務員",
    },
    {
      value: 4,
      name: "Supplier",
      text: "廠商",
    },
  ];
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
